var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.61958 2.17082C7.73932 1.8023 8.26068 1.8023 8.38042 2.17082L9.48179 5.56049C9.53534 5.7253 9.68892 5.83688 9.86222 5.83688H13.4263C13.8138 5.83688 13.9749 6.33273 13.6614 6.56049L10.778 8.65542C10.6378 8.75728 10.5792 8.93782 10.6327 9.10263L11.7341 12.4923C11.8538 12.8608 11.432 13.1673 11.1185 12.9395L8.23511 10.8446C8.09492 10.7427 7.90508 10.7427 7.76489 10.8446L4.88146 12.9395C4.56798 13.1673 4.14619 12.8608 4.26593 12.4923L5.3673 9.10263C5.42084 8.93782 5.36218 8.75728 5.22199 8.65542L2.33856 6.56049C2.02508 6.33273 2.18619 5.83688 2.57368 5.83688H6.13778C6.31108 5.83688 6.46466 5.7253 6.51821 5.56049L7.61958 2.17082Z",
    fill: "#001A39",
    stroke: "#001A39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/StarFilled.76f0db004fd5ee00ea9816ca415a2844.svg";
export { ForwardRef as ReactComponent };